import { PCT_CALC_TYPES } from '@/md/entities/progProd/progProdCalcTypeUtils';

// Concession is stored as a string whose meaning depends on the Calculation Type: a percent, a dollar amount,
// or (for FORMULA) the formula text itself
export const PriceResConcCellRenderer = ({ value, colDef, data }) => {
  if (value == null) return <span />;

  const calcType = data?.progProdCalcType;
  const num = Number(value);
  let text = value;
  const AMT_CALC_TYPES = ['AMT_OFF', 'CTRT_PRICE'];

  if (PCT_CALC_TYPES.includes(calcType) && Number.isFinite(num)) {
    // Percents are stored as decimals, so scaling to whole percent frees up two of the decimal places
    const nf = new Intl.NumberFormat('en-US', { maximumFractionDigits: Math.max(colDef.decimalPrecision - 2, 0) });
    text = `${nf.format(num * 100)}%`;
  } else if (AMT_CALC_TYPES.includes(calcType) && Number.isFinite(num)) {
    const nf = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: colDef.decimalPrecision,
    });
    text = nf.format(num);
  }

  return <span style={{ display: 'flex', justifyContent: 'flex-end' }}>{text}</span>;
};
